module.exports = __webpack_public_path__ + "public/img/factor-text.1a6104eb.png";